import { useQuery } from '@tanstack/react-query';
import { fetchOpticalHistory } from '../lib/api.js';

// Tendência óptica (rx/tx/distance) — varia em escala de horas/dias, refresh
// agressivo é desperdício. staleTime 5min cobre o ciclo do poller-optical (1h).
//
// MAP-33 — fecha o loop user-facing do AWS-12 + MAP-32 (DDL + writer postgres).
export function useOpticalHistory(sn, { days = 7, enabled = true } = {}) {
  return useQuery({
    queryKey: ['v2', 'onu-optical-history', sn, { days }],
    queryFn: () => fetchOpticalHistory(sn, days).then((r) => r.data),
    enabled: Boolean(sn) && enabled,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}
